<div (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()">
    <div class="measurement-point-photos" [class.not-selected]="isHidden" [class.img-size-large]="isLarge" [class.img-size-small]="!isLarge">
        <img [src]="'data:image/png;base64,'+image_data" />
        <div class="image-title-and-comment">
            {{image_title}} - {{image_comment}}
            <edit-data [canEdit]="true" (clickOut)="saveComment($event)"   (valueChanged) = "valueChanged($event)" [value]="image_comment" [dataType]="'text'" [vertResizeOnly]="true"></edit-data>
        </div>

        <div class="img-large-toggle" (click)="toggleImageSizeLarge()" *ngIf="displayToggleButton" matTooltip="Increase image size">
            <i class="material-icons show-hide-toggle__icon">zoom_in</i>
        </div>
        <div class="img-small-toggle" (click)="toggleImageSizeSmall()" *ngIf="displayToggleButton" matTooltip="Decrease image size">
            <i class="material-icons show-hide-toggle__icon">zoom_out</i>
        </div>
        <ng-container *ngIf="isRecommendationPhoto">
            <div class="show-hide-toggle" (click)="deleteImage()" *ngIf="displayToggleButton" matTooltip="Remove Image">
                <i class="material-icons show-hide-toggle__icon">clear</i>
            </div>
        </ng-container>
        <ng-container *ngIf="!isRecommendationPhoto">
            <div class="show-hide-toggle" [class.button_selected]="isHidden" (click)="toggleShowOrHide()" *ngIf="displayToggleButton" matTooltip="Toggle Show or Hide">
                <i class="material-icons show-hide-toggle__icon">not_interested</i>
            </div>
        </ng-container>
        
    </div>   
</div>